import { IOzonDropoffViewport } from 'api/ozonDelivery'

// Ozon accepts a viewport no wider than one degree on either axis.
const TILE_SIZE = 0.9
export const MAX_OZON_VISIBLE_TILES = 16

export interface IOzonDropoffTile {
  key: string
  viewport: IOzonDropoffViewport
}

export const getOzonDropoffTiles = (bounds: number[][]): {
  tiles: IOzonDropoffTile[]
  tooWide: boolean
} => {
  if (bounds.length < 2 || bounds.some((corner) => corner.length < 2 ||
    !Number.isFinite(corner[0]) || !Number.isFinite(corner[1]))) {
    return { tiles: [], tooWide: false }
  }

  const south = Math.min(...bounds.map((corner) => corner[0]))
  const north = Math.max(...bounds.map((corner) => corner[0]))
  const west = Math.min(...bounds.map((corner) => corner[1]))
  const east = Math.max(...bounds.map((corner) => corner[1]))
  const firstLat = Math.floor(south / TILE_SIZE)
  const lastLat = Math.floor((north - 1e-9) / TILE_SIZE)
  const firstLon = Math.floor(west / TILE_SIZE)
  const lastLon = Math.floor((east - 1e-9) / TILE_SIZE)
  if ((lastLat - firstLat + 1) * (lastLon - firstLon + 1) > MAX_OZON_VISIBLE_TILES) {
    return { tiles: [], tooWide: true }
  }

  const tiles: IOzonDropoffTile[] = []
  for (let lat = firstLat; lat <= lastLat; lat += 1) {
    for (let lon = firstLon; lon <= lastLon; lon += 1) {
      tiles.push({
        key: `${lat}:${lon}`,
        viewport: {
          left_bottom: {
            latitude: Number((lat * TILE_SIZE).toFixed(6)),
            longitude: Number((lon * TILE_SIZE).toFixed(6))
          },
          right_top: {
            latitude: Number(((lat + 1) * TILE_SIZE).toFixed(6)),
            longitude: Number(((lon + 1) * TILE_SIZE).toFixed(6))
          }
        }
      })
    }
  }
  return { tiles, tooWide: false }
}
